module.exports = __webpack_public_path__ + "img/11.179a6b0a.png";